import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'common-mailbox-icon',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './mailbox-icon.component.html',
  styleUrls: ['./mailbox-icon.component.scss'],
})
export class MailboxIconComponent {
  @Input() color!: string;
}
